import { Link } from "react-router-dom";

const columns = [
  {
    title: "内容频道",
    links: [
      { label: "娱乐资讯", to: "/news" },
      { label: "影视推荐", to: "/recommendations" },
      { label: "综艺动态", to: "/variety" },
      { label: "互动专区", to: "/community" },
    ],
  },
  {
    title: "关于红桃",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "团队介绍", to: "/about" },
      { label: "联系方式", to: "/about" },
      { label: "免责声明", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-primary-700 text-background-50">
      <div className="mx-auto w-full max-w-portal px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-primary-700">
                <i className="ri-heart-3-fill text-xl" />
              </span>
              <span className="font-heading text-xl font-black tracking-tight text-background-50">红桃网</span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-50/80">
              全方位娱乐资讯与互动平台。我们关注电影、电视剧与综艺，也关注每一个看完之后还想说点什么的人。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[
                { icon: "ri-weibo-line", name: "微博" },
                { icon: "ri-wechat-line", name: "微信" },
                { icon: "ri-video-line", name: "短视频" },
                { icon: "ri-mail-line", name: "邮箱" },
              ].map((item) => (
                <button
                  key={item.name}
                  type="button"
                  aria-label={item.name}
                  title={`${item.name}（演示链接）`}
                  className="flex h-8 w-8 cursor-pointer items-center justify-center rounded-md border border-background-50/25 text-background-50/80 transition-colors hover:border-accent-400 hover:text-accent-300"
                >
                  <i className={`${item.icon} text-base`} />
                </button>
              ))}
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">
                {column.title}
              </h4>
              <ul className="mt-4 space-y-2.5">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="inline-block text-sm text-background-50/80 transition-colors hover:text-accent-300"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading text-sm font-semibold tracking-wide text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-background-50/80">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-accent-400" />
                <span>hello@hongtao.example</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-400" />
                <span>城市文创园 B 座 7 层</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-accent-400" />
                <span>工作日 10:00 - 19:00</span>
              </li>
            </ul>
            <p className="mt-4 rounded-md border border-background-50/20 px-3 py-2 text-xs leading-relaxed text-background-50/65">
              本站为演示站点，联系邮箱与社交账号均为示意信息。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/20 pt-6 text-xs text-background-50/65 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 红桃网. 保留所有权利。</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <Link to="/about" className="transition-colors hover:text-accent-300">免责声明</Link>
            <Link to="/about" className="transition-colors hover:text-accent-300">隐私政策</Link>
            <span className="font-label">演示内容 · 不构成任何真实资讯</span>
          </div>
        </div>
      </div>
    </footer>
  );
}